import apiClient from './apiClient';

export const chatApi = {
  /**
   * Get all conversations
   * @returns {Promise} - API response with conversations list
   */
  getConversations: async () => {
    const response = await apiClient.get('/conversations');
    return response.data;
  },

  /**
   * Create a new conversation
   * @param {string} title - Optional conversation title
   * @returns {Promise} - API response with new conversation
   */
  createConversation: async (title = null) => {
    const response = await apiClient.post('/conversations', { title });
    return response.data;
  },

  /**
   * Get a specific conversation with messages
   * @param {number} conversationId - Conversation ID
   * @returns {Promise} - API response with conversation details and messages
   */
  getConversation: async (conversationId) => {
    const response = await apiClient.get(`/conversations/${conversationId}`);
    return response.data;
  },

  /**
   * Send a message to a conversation
   * @param {number} conversationId - Conversation ID
   * @param {string} content - Message content
   * @returns {Promise} - API response with user message and AI response
   */
  sendMessage: async (conversationId, content) => {
    const response = await apiClient.post(
      `/conversations/${conversationId}/messages`,
      { content }
    );
    return response.data;
  },

  /**
   * Delete a conversation
   * @param {number} conversationId - Conversation ID
   * @returns {Promise} - API response
   */
  deleteConversation: async (conversationId) => {
    const response = await apiClient.delete(`/conversations/${conversationId}`);
    return response.data;
  },

  /**
   * Upload a folder (as a zip file) to the conversation workspace
   * @param {number} conversationId - Conversation ID
   * @param {FormData} formData - FormData object containing the file and optional destination path
   * @returns {Promise} - API response with upload details
   */
  uploadFolder: async (conversationId, formData) => {
    const response = await apiClient.post(
      `/conversations/${conversationId}/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },
};

export default chatApi;